<template>
  <div class="custom-verify">
    <form @submit.prevent="submit">
      <div class="form-floating mb-4 text-center">
        <img src="/media/live/logo.png" alt="Corsync" class="logo" />
      </div>
      <div class="form-floating mb-4 text-center">
        <h4>Verify Email</h4>
      </div>
      <div class="form-floating mb-4">
        <p>Thanks for signing up!</p>
        <p>
          Before getting started, please verify your email address by clicking
          on the link we just emailed to you? If you didn't receive the email,
          we will gladly send you another.
        </p>
        <p>
          A new verification link has been sent to the email address you
          provided during registration.
        </p>
      </div>
      <div class="form-floating mb-4 text-center">
        <breeze-button
          :class="{ 'opacity-25': form.processing }"
          :disabled="form.processing"
          class="btn btn-primary"
        >
          Resend Verification Email
        </breeze-button>
      </div>
      <div class="form-floating mb-4 text-center">
        <inertia-link
          :href="route('logout')"
          method="post"
          as="button"
          class="btn btn-link"
          >Log Out</inertia-link
        >
      </div>
    </form>
  </div>
</template>
<script>
import BreezeButton from '@/Components/Elements/Button'
export default {
  components: {
    BreezeButton,
  },
  props: {
    status: String,
  },
  data() {
    return {
      form: this.$inertia.form(),
    }
  },
  methods: {
    submit() {
      this.form.post(this.route('verification.send'))
    },
  },
  computed: {
    verificationLinkSent() {
      return this.status === 'verification-link-sent'
    },
  },
}
</script>
<style lang="scss" scoped>
.logo {
  height: 48px;
  width: auto;
}
.custom-verify {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
</style>
